export default "__VITE_ASSET__CtZAxeTK__"